import React from 'react'

const MatrixSortAnswer = ({ ...props }) => {
    const answerChoices = props.answerChoices ?? []
    const userAnswer = props.userAnswer.answer_data ? JSON.parse(props.userAnswer.answer_data ) : []
   /**
     * TODO: know how to parse the userAnswer; for now, we can't display what's right or wrong because the answer data is decrypted;
     */
    return (
      <div className={`msync-question-container__answer__matrixsortanswer`}>
            {
                answerChoices.map((choice, index) => {
                    return (
                        <div className='msync_matrix_sort_answer'>
                            <input type='text' value={choice._answer ?? ""} key={index} disabled />
                            <input type='text' value={""} key={index+"user_answer"} disabled />
                        </div>
                    )
                })
            }
        </div>
    )
}

export default MatrixSortAnswer